import type * as Highcharts from 'highcharts';
import type { BeniBreakdown } from 'lumen/models';

export const PACE_CHART_SERIES_IDS = {
  OWN: 'own',
  OWN_REFERENCE: 'ownReference',
  PRIMARY_COMPARISON_SET: 'primaryComparisonSet',
  PRIMARY_COMPARISON_SET_REFERENCE: 'primaryComparisonSetReference',
  SECONDARY_COMPARISON_SET: 'secondaryComparisonSet',
  SECONDARY_COMPARISON_SET_REFERENCE: 'secondaryComparisonSetReference',
};
export type PaceChartSeriesId =
  (typeof PACE_CHART_SERIES_IDS)[keyof typeof PACE_CHART_SERIES_IDS];

export interface PaceChartSeriesPoint {
  segmentation?: BeniBreakdown;
  showWarningForWeek?: boolean;
  x: number;
  y: number | null;
}

export interface PaceChartSeries extends Highcharts.SeriesOptions {
  color: Highcharts.ColorString | Highcharts.GradientColorObject;
  data: PaceChartSeriesPoint[];
  id?: PaceChartSeriesId;
  marker: {
    enabled: boolean;
  };
  name: string;
  visible: boolean;
}
